export enum AlertEnums {
  addSuccess = 'L\'élément a été créée avec succès',
  updateSuccess = 'L\'élément a été mise à jour avec succès',
  EditError = 'Une erreur est survenue, veuillez réessayer plus tard',
  deleteSuccess = 'L\'élément a été supprimée avec succès',
  getSuccess = 'Les données ont été recupérées avec succès',
  QUOTATION_SENT_SUCCESS = 'QUOTATION_SENT_SUCCESS',
  QUOTATION_DRAFT_SUCCESS = 'QUOTATION_DRAFT_SUCCESS',
  QUOTATION_EDIT_SUCCESS = 'QUOTATION_EDIT_SUCCESS',
  QUOTATION_REQUEST_SUCCESS = 'QUOTATION_REQUEST_SUCCESS',
  QUOTATION_ACCEPT_SUCCESS = 'QUOTATION_ACCEPT_SUCCESS',
  QUOTATION_DECLINE_SUCCESS = 'QUOTATION_DECLINE_SUCCESS',
  QUOTATION_CANCEL_SUCCESS = 'QUOTATION_CANCEL_SUCCESS',
  QUOTATION_ERROR = 'QUOTATION_ERROR',
}

export enum ToastMessages {
  CredentialsError = 'CREDENTIALS_ERROR',
  PasswordResetEmailSent = 'PASSWORD_RESET_EMAIL_SENT',
  PasswordResetError = 'PASSWORD_RESET_ERROR',
  PasswordResetSuccess = 'PASSWORD_RESET_SUCCESS',
  PasswordResetFailed = 'PASSWORD_RESET_FAILED',
  UnsubscribeFailed = 'UNSUBSCRIBE_FAILED',
  UnsubscribeSuccess = 'UNSUBSCRIBE_SUCCESS',
}
